import { IUser, IInstallation, IHeader, IBootstrap, IntegrationType } from '../models';
import { doFetch, generateHeaders } from '../helpers/fetcher';

export * from './integration';

export const getHeaderData = async (user: IUser): Promise<IHeader> =>
    await doFetch('header', generateHeaders(user));

export const getBootstrapData = async (user: IUser, installation: IInstallation): Promise<IBootstrap> =>
    await doFetch(`bootstrap/${installation.integrationType}`, generateHeaders(user));

export const getOrganisations = async (user: IUser, integrationType: IntegrationType) =>
    await doFetch(`organisations/${integrationType}`, generateHeaders(user),)